"use strict";
/*
 * Created on 19. 9. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ValidationResultConverter_1 = require("../../core/model/errors/conversions/ValidationResultConverter");

var RealImpactValueConverter_1 = require("../../impact/conversions/RealImpactValueConverter");

var UserInfoConverter_1 = require("../../user/conversions/UserInfoConverter");

var ReleaseConverter_1 = require("./ReleaseConverter");

var ReleaseEditInfoConverter_1 = require("./ReleaseEditInfoConverter");

var ReleasePartConverter_1 = require("./ReleasePartConverter");

var SelloutItemFilterConverter_1 = require("./sellout/SelloutItemFilterConverter");

var SelloutReleasePartConverter_1 = require("./sellout/SelloutReleasePartConverter");

var SelloutReleaseSnapshotConverter_1 = require("./sellout/SelloutReleaseSnapshotConverter");
/**
 * Default implementation of release converter.
 *
 * @author Radek Beran
 */


var ReleaseConverterImpl =
/*#__PURE__*/
function (_ReleaseConverter_1$R) {
  _inherits(ReleaseConverterImpl, _ReleaseConverter_1$R);

  function ReleaseConverterImpl(releasePartConverter, selloutReleasePartConverter, userInfoConverter, editInfoConverter, validationResultConverter, realImpactValueConverter, selloutItemFilterConverter, selloutReleaseSnapshotConverter) {
    var _this;

    _classCallCheck(this, ReleaseConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleaseConverterImpl).call(this, releasePartConverter, selloutReleasePartConverter, userInfoConverter, editInfoConverter, validationResultConverter, realImpactValueConverter, selloutItemFilterConverter, selloutReleaseSnapshotConverter));
    _this.releasePartConverter = releasePartConverter;
    _this.selloutReleasePartConverter = selloutReleasePartConverter;
    _this.userInfoConverter = userInfoConverter;
    _this.editInfoConverter = editInfoConverter;
    _this.validationResultConverter = validationResultConverter;
    _this.realImpactValueConverter = realImpactValueConverter;
    _this.selloutItemFilterConverter = selloutItemFilterConverter;
    _this.selloutReleaseSnapshotConverter = selloutReleaseSnapshotConverter;
    return _this;
  }

  return ReleaseConverterImpl;
}(ReleaseConverter_1.ReleaseConverter);

ReleaseConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __param(2, typescript_ioc_1.Inject), __param(3, typescript_ioc_1.Inject), __param(4, typescript_ioc_1.Inject), __param(5, typescript_ioc_1.Inject), __param(6, typescript_ioc_1.Inject), __param(7, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ReleasePartConverter_1.ReleasePartConverter, SelloutReleasePartConverter_1.SelloutReleasePartConverter, UserInfoConverter_1.UserInfoConverter, ReleaseEditInfoConverter_1.ReleaseEditInfoConverter, ValidationResultConverter_1.ValidationResultConverter, RealImpactValueConverter_1.RealImpactValueConverter, SelloutItemFilterConverter_1.SelloutItemFilterConverter, SelloutReleaseSnapshotConverter_1.SelloutReleaseSnapshotConverter])], ReleaseConverterImpl);
exports.ReleaseConverterImpl = ReleaseConverterImpl;